import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { AuthContextProvider } from './context/AuthContext'
import { FeedContextProvider } from './context/FeedContext/FeedContext'
import { BrowserRouter as Router } from 'react-router-dom'
import { SettingsContextProvider } from './context/SettingsContext/SettingsContext'
import { createGenerateClassName, StylesProvider } from '@mui/styles'
import { v4 as uuidv4 } from 'uuid'

const generateClassName = createGenerateClassName({
  productionPrefix: `${uuidv4()}_Hutupia_${Math.random()}`,
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Router>
      <AuthContextProvider>
        <SettingsContextProvider>
          <FeedContextProvider>
            <StylesProvider generateClassName={generateClassName}>
              <App />
            </StylesProvider>
          </FeedContextProvider>
        </SettingsContextProvider>
      </AuthContextProvider>
    </Router>
  </React.StrictMode>
)
